import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Menu, Segment } from 'semantic-ui-react';
import { useAppState } from '../App/AppContext';
import firebase from '../firebase';
import { Logo } from './Logo';

export const Component = () => {
  const { user } = useAppState();

  const handleClick = () => {
    firebase.auth().signOut();
  };

  return (
    <Segment inverted>
      <Menu inverted secondary>
        <Container>
          <Link to="/">
            <Menu.Item fitted>
              <Logo />
            </Menu.Item>
          </Link>
          <Menu.Item fitted position="right">
            {user ? (
              <div>
                <div>Bienvenido</div>
                <div onClick={handleClick}>{user.email}</div>
              </div>
            ) : (
              <Link to="/elink">
                <Button>Log in</Button>
              </Link>
            )}
          </Menu.Item>
        </Container>
      </Menu>
    </Segment>
  );
};
